module.exports = __webpack_public_path__ + "static/img/more-but.24506cb6.png";